import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes$1 from 'prop-types';
import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { PropTypes } from '@panneau/core';
import { useLocales, useFormsComponents, FormProvider } from '@panneau/core/contexts';
import { useResourceUrlGenerator, useForm } from '@panneau/core/hooks';
import { getComponentFromName } from '@panneau/core/utils';
import { useResourceStore, useResourceUpdate, useResourceDestroy, useResourceClone } from '@panneau/data';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Button from '@panneau/element-button';
import Form from '@panneau/element-form';
import { useResourceValues } from '@panneau/intl';

var _excluded$2 = ["resource", "action", "previous", "status", "value", "onSubmit", "errors", "generalError", "loading", "className"];
var propTypes$2 = {
  resource: PropTypes.resource.isRequired,
  action: PropTypes$1.string,
  previous: PropTypes$1.string,
  fields: PropTypes.fields.isRequired,
  value: PropTypes$1.object,
  // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes$1.func.isRequired,
  onSubmit: PropTypes$1.func,
  status: PropTypes.formStatus,
  generalError: PropTypes$1.string,
  errors: PropTypes$1.objectOf(PropTypes$1.arrayOf(PropTypes$1.string)),
  loading: PropTypes$1.bool,
  className: PropTypes$1.string
};
var defaultProps$2 = {
  action: null,
  previous: null,
  status: null,
  value: null,
  onSubmit: null,
  generalError: null,
  errors: null,
  loading: false,
  className: null
};
var DeleteForm = function DeleteForm(_ref) {
  var resource = _ref.resource,
    action = _ref.action,
    previous = _ref.previous;
    _ref.status;
    var value = _ref.value,
    onSubmit = _ref.onSubmit;
    _ref.errors;
    var generalError = _ref.generalError,
    loading = _ref.loading,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var _ref2 = value || {},
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? null : _ref2$id;
  var resourceValues = useResourceValues(resource, {
    id: id
  });
  // const { text, background } = usePanneauColorScheme();

  return /*#__PURE__*/React.createElement(Form, Object.assign({
    className: classNames(['form', _defineProperty({
      'invalid-feedback': generalError !== null
    }, className, className !== null)]),
    action: action,
    onSubmit: onSubmit,
    withoutActions: true,
    withoutErrors: true,
    disabled: loading
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classNames(['card', _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    values: resourceValues,
    id: "yzfiXJ",
    defaultMessage: [{
      "type": 0,
      "value": "Are you sure you want to delete "
    }, {
      "type": 1,
      "value": "the_singular"
    }, {
      "type": 0,
      "value": " #"
    }, {
      "type": 1,
      "value": "id"
    }, {
      "type": 0,
      "value": "?"
    }]
  }), generalError ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "y9zauY",
    defaultMessage: [{
      "type": 0,
      "value": "An error occured and we could not delete this item successfully."
    }]
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex"
  }, previous !== null ? /*#__PURE__*/React.createElement(Button, {
    href: previous,
    className: "me-2",
    theme: "secondary",
    outline: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "PyxZY2",
    defaultMessage: [{
      "type": 0,
      "value": "Cancel"
    }]
  })) : null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: "ms-auto",
    theme: "danger",
    disabled: loading
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Bhu3B2",
    defaultMessage: [{
      "type": 0,
      "value": "Delete"
    }]
  })))));
};
DeleteForm.propTypes = propTypes$2;
DeleteForm.defaultProps = defaultProps$2;

var _excluded$1 = ["resource", "action", "previous", "status", "value", "onSubmit", "errors", "generalError", "loading", "className"];
var propTypes$1 = {
  resource: PropTypes.resource.isRequired,
  action: PropTypes$1.string,
  previous: PropTypes$1.string,
  fields: PropTypes.fields.isRequired,
  value: PropTypes$1.object,
  // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes$1.func.isRequired,
  onSubmit: PropTypes$1.func,
  status: PropTypes.formStatus,
  generalError: PropTypes$1.string,
  errors: PropTypes$1.objectOf(PropTypes$1.arrayOf(PropTypes$1.string)),
  loading: PropTypes$1.bool,
  className: PropTypes$1.string
};
var defaultProps$1 = {
  action: null,
  previous: null,
  status: null,
  value: null,
  onSubmit: null,
  generalError: null,
  errors: null,
  loading: false,
  className: null
};
var DuplicateForm = function DuplicateForm(_ref) {
  var resource = _ref.resource,
    action = _ref.action,
    previous = _ref.previous;
    _ref.status;
    var value = _ref.value,
    onSubmit = _ref.onSubmit;
    _ref.errors;
    var generalError = _ref.generalError,
    loading = _ref.loading,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var _ref2 = value || {},
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? null : _ref2$id;
  var resourceValues = useResourceValues(resource, {
    id: id
  });
  return /*#__PURE__*/React.createElement(Form, Object.assign({
    className: classNames(['form', _defineProperty({
      'invalid-feedback': generalError !== null
    }, className, className !== null)]),
    action: action,
    onSubmit: onSubmit,
    withoutActions: true,
    withoutErrors: true,
    disabled: loading
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classNames(['card', _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    values: resourceValues,
    id: "ZhnMCD",
    defaultMessage: [{
      "type": 0,
      "value": "Are you sure you want to duplicate "
    }, {
      "type": 1,
      "value": "the_singular"
    }, {
      "type": 0,
      "value": " #"
    }, {
      "type": 1,
      "value": "id"
    }, {
      "type": 0,
      "value": "?"
    }]
  }), generalError ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "y9zauY",
    defaultMessage: [{
      "type": 0,
      "value": "An error occured and we could not delete this item successfully."
    }]
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex"
  }, previous !== null ? /*#__PURE__*/React.createElement(Button, {
    href: previous,
    className: "me-2",
    theme: "secondary",
    outline: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "PyxZY2",
    defaultMessage: [{
      "type": 0,
      "value": "Cancel"
    }]
  })) : null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: "ms-auto",
    theme: "warning",
    disabled: loading
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "HzCxmr",
    defaultMessage: [{
      "type": 0,
      "value": "Duplicate"
    }]
  })))));
};
DuplicateForm.propTypes = propTypes$1;
DuplicateForm.defaultProps = defaultProps$1;

var _excluded = ["component", "resource", "onSuccess", "item", "type", "isDelete", "isDuplicate"];
var propTypes = {
  resource: PropTypes.resource.isRequired,
  item: PropTypes$1.object,
  // eslint-disable-line react/forbid-prop-types
  type: PropTypes$1.string,
  component: PropTypes$1.string,
  onSuccess: PropTypes$1.func,
  isDelete: PropTypes$1.bool,
  isDuplicate: PropTypes$1.bool
};
var defaultProps = {
  item: null,
  type: null,
  component: null,
  onSuccess: null,
  isDelete: false,
  isDuplicate: false
};
var ResourceForm = function ResourceForm(_ref) {
  var component = _ref.component,
    resource = _ref.resource,
    onSuccess = _ref.onSuccess,
    item = _ref.item,
    type = _ref.type,
    isDelete = _ref.isDelete,
    isDuplicate = _ref.isDuplicate,
    props = _objectWithoutProperties(_ref, _excluded);
  var locales = useLocales();
  var FormComponents = useFormsComponents();
  var _ref2 = item || {},
    _ref2$id = _ref2.id,
    itemId = _ref2$id === void 0 ? null : _ref2$id;
  var _resource$fields = resource.fields,
    resourceFields = _resource$fields === void 0 ? [] : _resource$fields,
    _resource$types = resource.types,
    resourceTypes = _resource$types === void 0 ? [] : _resource$types,
    forms = resource.forms;
  var resourceType = type !== null ? resourceTypes.find(function (it) {
    return it.id === type;
  }) || null : null;
  var _ref3 = resourceType || {},
    _ref3$fields = _ref3.fields,
    resourceTypeFields = _ref3$fields === void 0 ? null : _ref3$fields;
  var isCreate = item === null || !itemId;

  // Pick fields from resource root or form
  var _ref4 = forms || {},
    _ref4$default = _ref4["default"],
    defaultForm = _ref4$default === void 0 ? null : _ref4$default,
    _ref4$create = _ref4.create,
    createForm = _ref4$create === void 0 ? null : _ref4$create,
    _ref4$edit = _ref4.edit,
    editForm = _ref4$edit === void 0 ? null : _ref4$edit,
    _ref4$delete = _ref4["delete"],
    deleteForm = _ref4$delete === void 0 ? null : _ref4$delete;
  var _ref5 = defaultForm || {},
    _ref5$fields = _ref5.fields,
    defaultFields = _ref5$fields === void 0 ? null : _ref5$fields,
    defaultComponent = _ref5.component;
  var createOrEditSource = isCreate ? createForm || {} : editForm || {};
  var _ref6 = isDelete ? deleteForm || {} : createOrEditSource || {},
    _ref6$fields = _ref6.fields,
    formFields = _ref6$fields === void 0 ? null : _ref6$fields,
    _ref6$component = _ref6.component,
    formComponent = _ref6$component === void 0 ? null : _ref6$component;
  var finalFields = useMemo(function () {
    return (formFields || defaultFields || resourceTypeFields || resourceFields).filter(function (_ref7) {
      var _ref7$settings = _ref7.settings,
        _ref7$settings2 = _ref7$settings === void 0 ? {} : _ref7$settings,
        _ref7$settings2$hidde = _ref7$settings2.hiddenInForm,
        hiddenInForm = _ref7$settings2$hidde === void 0 ? false : _ref7$settings2$hidde;
      return !hiddenInForm;
    });
  }, [formFields, defaultFields, resourceTypeFields, resourceFields]);

  // Form routes
  var resourceRoute = useResourceUrlGenerator(resource);
  var _useResourceStore = useResourceStore(resource),
    store = _useResourceStore.store,
    storing = _useResourceStore.loading;
  var _useResourceUpdate = useResourceUpdate(resource, item !== null ? itemId : null),
    update = _useResourceUpdate.update,
    updating = _useResourceUpdate.loading;
  var _useResourceDestroy = useResourceDestroy(resource, item !== null ? itemId : null),
    destroy = _useResourceDestroy.destroy,
    destroying = _useResourceDestroy.loading;
  var _useResourceClone = useResourceClone(resource, item !== null ? itemId : null),
    clone = _useResourceClone.clone,
    cloning = _useResourceClone.loading;
  var loading = storing || updating || destroying || cloning;

  // Post actions
  var postForm = useCallback(function (action, data) {
    if (isDelete) {
      return destroy();
    }
    if (isDuplicate) {
      return clone();
    }
    if (isCreate) {
      return store(data);
    }
    return update(data);
  }, [itemId, isCreate, isDelete, isDuplicate, destroy, clone, store, update]);

  // Form state
  var getInitialValue = useCallback(function () {
    return item !== null ? item : finalFields.reduce(function (defaultValues, _ref8) {
      var name = _ref8.name,
        _ref8$defaultValue = _ref8.defaultValue,
        defaultValue = _ref8$defaultValue === void 0 ? null : _ref8$defaultValue;
      return defaultValue !== null ? _objectSpread(_objectSpread({}, defaultValues), {}, _defineProperty({}, name, defaultValue)) : defaultValues;
    }, type !== null ? {
      type: type
    } : null);
  }, [item, type, finalFields]);
  var _useState = useState(getInitialValue()),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValueState = _useState2[1];
  var setValue = useCallback(function (newValue) {
    setValueState(newValue);
  }, [setValueState]);

  // Form action
  var action = isCreate ? resourceRoute('store') : resourceRoute('update', {
    id: itemId
  });
  action = isDelete ? resourceRoute('destroy', {
    id: itemId
  }) : action;
  action = isDuplicate ? resourceRoute('clone', {
    id: itemId
  }) : action;
  var _useForm = useForm({
      action: action,
      fields: finalFields,
      value: value,
      postForm: postForm,
      setValue: setValue,
      onComplete: onSuccess,
      locales: locales
    }),
    fields = _useForm.fields,
    onSubmit = _useForm.onSubmit,
    status = _useForm.status,
    generalError = _useForm.generalError,
    errors = _useForm.errors;
  var defaultFormName = isDelete || isDuplicate ? component || formComponent || null : component || formComponent || defaultComponent || 'normal';
  var finalComponent = component;
  if (isDelete) {
    finalComponent = DeleteForm;
  }
  if (isDuplicate) {
    finalComponent = DuplicateForm;
  }

  // Form component
  var FormComponent = getComponentFromName(defaultFormName, FormComponents, finalComponent);

  // Listen to item value change - this is important
  useEffect(function () {
    setValue(getInitialValue());
  }, [getInitialValue, setValue]);
  return /*#__PURE__*/React.createElement(FormProvider, {
    value: value,
    setValue: setValue
  }, /*#__PURE__*/React.createElement(FormComponent, Object.assign({}, props, {
    status: status,
    resource: resource,
    item: item,
    fields: fields,
    generalError: generalError,
    errors: errors,
    action: action,
    onSubmit: onSubmit,
    isCreate: isCreate,
    value: value,
    onChange: setValue,
    loading: loading
  })));
};
ResourceForm.propTypes = propTypes;
ResourceForm.defaultProps = defaultProps;

export { ResourceForm as default };
